import React, { useEffect, useState } from 'react';
import OverallRoundScore from './OverallRoundScore';
import ScorecardTable from './ScorecardTable';
import ScorecardChart from './ScorecardChart';
import { GetMeetingScoreCardAPIResponse } from 'types';
import { generateScorecardChartData, generateScorecardTableData } from 'src/utils/scorecard';

interface Props {
	meetingScore: number;
	skillScores: GetMeetingScoreCardAPIResponse['allMeetingSkillScores'];
}

const RoundScorecard = ({ meetingScore, skillScores }: Props) => {
	const [scorecardChartData, setScorecardChartData] = useState<
		{
			name: string;
			userRating: number;
		}[]
	>([]);
	const [scorecardTableData, setScorecardTableData] = useState<
		{
			topic: string;
			score: number;
		}[]
	>([]);

	const tableTopLineContent = `Skill Levels Assessed from Competency Mapping Interview`;

	const score = Math.round(meetingScore);

	useEffect(() => {
		const specificRoundTypeSkillScore = skillScores;

		if (specificRoundTypeSkillScore) {
			setScorecardChartData(generateScorecardChartData(specificRoundTypeSkillScore));
			setScorecardTableData(generateScorecardTableData(specificRoundTypeSkillScore));
		}
	}, [skillScores]);

	return (
		<>
			<div className="rounded-[8px] overflow-hidden border dark:border-0">
				<div className="py-[18px] px-4 bg-gray-100 border-b dark:border-b-0 dark:bg-[#18222D] text-base font-medium">
					Round Scorecard
				</div>

				<div className="p-4 bg-white dark:bg-[#1F2A37]">
					<OverallRoundScore score={score} />

					{/* <div className="mt-4 overflow-x-auto">
						<ScorecardTabsComponent tab={tab} setTab={setTab} tabsConfig={tabsConfig} />
					</div> */}

					<div className="mt-4 md:mt-10 flex justify-between gap-8 sm:block">
						<div className="sm:hidden grow-2">
							<ScorecardChart chartData={scorecardChartData} />
						</div>

						<div className="w-[400px] sm:w-full">
							<div className="dark:text-[#F2F2F5] dark:md:text-[#EBEBF0] text-sm md:text-base font-normal">
								{tableTopLineContent}
							</div>

							<div className="mt-4 md:mt-[50px] md:h-[400px] md:overflow-y-auto">
								<ScorecardTable tableData={scorecardTableData} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default RoundScorecard;
